import React, { createRef } from "react";
import { Chart } from "chart.js";
import {
  LineController, LineElement, PointElement,
  LinearScale, CategoryScale, Legend, Tooltip
} from "chart.js";
import { fetchRevenueChart } from "../../../util/settings_api_util";

Chart.register(LineController, LineElement, PointElement, LinearScale, CategoryScale, Legend, Tooltip);

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// Distinct colors cycled per year
const COLORS = ["#1B264F", "#2E86AB", "#E4B363", "#A23B72", "#3CAEA3", "#F45B69", "#6B4E71", "#8FB339"];

// Years beyond the most recent N start hidden (toggle on via legend)
const DEFAULT_VISIBLE_YEARS = 4;

export default class RevenueChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = { years: [], loaded: false };
    this.chartRef = createRef();
    this.chart = null;
  }

  componentDidMount() {
    fetchRevenueChart().then(data => {
      this.setState({ years: data.years || [], loaded: true }, () => this.buildChart());
    }).catch(() => {
      this.setState({ loaded: true });
    });
  }

  componentWillUnmount() {
    if (this.chart) this.chart.destroy();
  }

  buildChart() {
    if (!this.chartRef.current || this.state.years.length === 0) return;

    const yearCount = this.state.years.length;
    const datasets = this.state.years.map((entry, i) => {
      const color = COLORS[i % COLORS.length];
      return {
        label: String(entry.year),
        data: entry.months,
        borderColor: color,
        backgroundColor: color,
        tension: 0.3,
        pointRadius: 3,
        borderWidth: 2,
        // hide older years by default; user clicks legend to show
        hidden: i < yearCount - DEFAULT_VISIBLE_YEARS
      };
    });

    if (this.chart) this.chart.destroy();
    this.chart = new Chart(this.chartRef.current, {
      type: "line",
      data: { labels: MONTHS, datasets },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: { mode: "index", intersect: false },
        plugins: {
          legend: {
            position: "top",
            labels: { usePointStyle: true, padding: 16 }
          },
          tooltip: {
            callbacks: {
              label: (ctx) => `${ctx.dataset.label}: $${Number(ctx.parsed.y).toLocaleString()}`
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: { callback: (v) => `$${Number(v).toLocaleString()}` }
          }
        }
      }
    });
  }

  render() {
    const { loaded, years } = this.state;

    return (
      <div className="settingsPreferencesGroupingDiv">
        <div className="settingsPreferences">
          <div className="settingsComponentHeading">Revenue by Month</div>
          <div className="settingsGroup">
            {loaded && years.length === 0 && (
              <div style={{ padding: "16px 4px", color: "#777" }}>No revenue data found.</div>
            )}
            <div style={{ position: "relative", height: "460px", width: "100%" }}>
              <canvas ref={this.chartRef} />
            </div>
            <div style={{ marginTop: "12px", color: "#777", fontSize: "13px" }}>
              Click a year in the legend to show or hide it. Older years start hidden.
            </div>
          </div>
        </div>
      </div>
    );
  }
}